// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__2EWeR","info":"Note_info__3W_kP","note":"Note_note__vfOfm","actions":"Note_actions__2bHlV"};